<template>
  <div>
    <div class="block">
    <el-carousel trigger="click" :interval="5000" width="100%" height="80vh">
      <el-carousel-item v-for="(item,index) in imgList" :key="index">
        <el-image :src="item.url" style="width: 100%; height: 80vh"></el-image>
      </el-carousel-item>
    </el-carousel>
  </div>
  </div>
</template>

<script>
export default {
  name:'home',
  data(){
    return{
      imgList:[]
    }
  },
  beforeMount(){
    this.imgList = [
        {url:require('../../assets/banner1.jpg')},
        {url:require('../../assets/banner2信用创造价值.jpg')},
        {url:require('../../assets/banner3资金安全.jpg')},
        {url:require('../../assets/banner4-反欺诈.jpg')},
      ]
  }
};
</script>

<style lang="scss" scoped>
.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
     background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
     background-color: #d3dce6;
  }
</style>


// WEBPACK FOOTER //
// src/view/Home/index.vue